import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { GenericService } from '../../services/generic.service';
import { AggregationService } from '../../services/aggregation.service';
import { AccountsService } from './services/accounts.service';
import { AccountsBalanceService } from './services/accounts-balance/accounts-balance.service';
import { AccountAdditionalInfoService } from './services/account-additional-info/account-additional-info.service';
var AccountsComponent = /** @class */ (function () {
    function AccountsComponent(genericService, aggregationService, accountsService, accountsBalanceService, accountAdditionalInfoService) {
        this.genericService = genericService;
        this.aggregationService = aggregationService;
        this.accountsService = accountsService;
        this.accountsBalanceService = accountsBalanceService;
        this.accountAdditionalInfoService = accountAdditionalInfoService;
        this.clearCache = false;
        this.redesign = false;
    }
    AccountsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fetchAccounts();
        this.genericService.toggleObs$.subscribe(function (res) {
            _this.redesign = res;
        });
    };
    AccountsComponent.prototype.fetchAccounts = function () {
        var _this = this;
        this.accountsService.getAccounts(this.productType, this.clearCache).subscribe(function (accountsInfo) {
            if (accountsInfo) {
                if (accountsInfo.responseCode === '403') {
                    _this.genericService.callUiLogger(accountsInfo.responseStatus);
                    _this.aggregationService.emitAggDone();
                }
                _this.genericService.addDynamicProductTypeData(accountsInfo.contractSummaryResponse || [], _this.productType);
                _this.accountsInfo = accountsInfo;
                if (accountsInfo.contractSummaryResponse && accountsInfo.contractSummaryResponse.contractSummary) {
                    _this.initiateAccountBalanceInfoUpdate();
                    _this.initiateAccountAdditionalInfoUpdate();
                }
            }
            else {
                _this.accountsInfo = {};
                _this.genericService.addDynamicProductTypeData({ contractSummary: [], responseCode: '200' }, _this.productType);
            }
            _this.accountsInfo.businessUnit = _this.accountsInfo.businessUnit ? _this.accountsInfo.businessUnit : "Investments";
            //  this.aggregationService.emitAggDone();
        }, function (error) {
            var errmsg = error.error || {};
            if (error.responseCode === '403') {
                _this.genericService.callUiLogger(errmsg);
            }
            _this.accountsInfo = errmsg;
            _this.accountsInfo.businessUnit = "Investments";
            if (!errmsg.responseCode)
                _this.accountsInfo.responseCode = error.responseCode;
            console.log("contractsummary error: ", _this.accountsInfo);
            _this.aggregationService.emitAggDone();
        });
    };
    AccountsComponent.prototype.initiateAccountBalanceInfoUpdate = function () {
        var _this = this;
        var accountReferenceIds = this.getAccountReferenceIdsForValueRefresh();
        if (accountReferenceIds.length === 0) {
            this.resetValueRefreshDisplay();
            return;
        }
        this.accountsBalanceService.getAccountsBalance(this.productType, accountReferenceIds).subscribe(function (accountBalancesInfo) {
            _this.updateAccountBalances(accountBalancesInfo);
            _this.resetValueRefreshDisplay();
        });
    };
    AccountsComponent.prototype.initiateAccountAdditionalInfoUpdate = function () {
        var _this = this;
        var accountInfos = this.getAccountInfos();
        if (accountInfos.length === 0) {
            return;
        }
        this.accountAdditionalInfoService.getAdditionalSecondaryInfos(accountInfos).subscribe(function (accountAdditionalInfos) {
            _this.updateAccountSecondaryInfos(accountAdditionalInfos);
        });
    };
    AccountsComponent.prototype.getAccountReferenceIdsForValueRefresh = function () {
        return this.getAccountInfos().filter(function (account) {
            return account.needValueRefresh;
        }).map(function (account) {
            return account.referenceId;
        });
    };
    AccountsComponent.prototype.getAccountInfos = function () {
        var contracts;
        try {
            contracts = this.accountsInfo.contractSummaryResponse.contractSummary;
        }
        catch (e) {
            return [];
        }
        return contracts.filter(function (contract) {
            return contract && contract.referenceId;
        }).map(function (contract) {
            return {
                referenceId: contract.referenceId,
                needValueRefresh: contract.needValueRefresh,
                sweepOption: contract.additionalValues ? contract.additionalValues.sweepOption : null,
                interestYTD: contract.additionalValues ? contract.additionalValues.interestYTD : null
            };
        });
    };
    AccountsComponent.prototype.resetValueRefreshDisplay = function () {
        var e_1, _a;
        var contracts;
        try {
            contracts = this.accountsInfo.contractSummaryResponse.contractSummary;
        }
        catch (e) {
            // nothing here
        }
        try {
            for (var contracts_1 = tslib_1.__values(contracts), contracts_1_1 = contracts_1.next(); !contracts_1_1.done; contracts_1_1 = contracts_1.next()) {
                var contract = contracts_1_1.value;
                if (contract) {
                    contract.needValueRefresh = false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (contracts_1_1 && !contracts_1_1.done && (_a = contracts_1.return)) _a.call(contracts_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    AccountsComponent.prototype.updateAccountBalances = function (accountBalancesInfo) {
        var e_2, _a, e_3, _b;
        if (!accountBalancesInfo || accountBalancesInfo.length === 0) {
            return;
        }
        var contracts;
        try {
            contracts = this.accountsInfo.contractSummaryResponse.contractSummary;
        }
        catch (e) {
            return;
        }
        try {
            for (var accountBalancesInfo_1 = tslib_1.__values(accountBalancesInfo), accountBalancesInfo_1_1 = accountBalancesInfo_1.next(); !accountBalancesInfo_1_1.done; accountBalancesInfo_1_1 = accountBalancesInfo_1.next()) {
                var balanceInfo = accountBalancesInfo_1_1.value;
                try {
                    for (var contracts_2 = tslib_1.__values(contracts), contracts_2_1 = contracts_2.next(); !contracts_2_1.done; contracts_2_1 = contracts_2.next()) {
                        var contract = contracts_2_1.value;
                        if (contract.referenceId === balanceInfo.referenceId) {
                            try {
                                contract.primaryContractValue.value = balanceInfo.accountValue + '';
                            }
                            catch (e) {
                                // nothing here
                            }
                            contract.asOfDate = balanceInfo.asOfDate;
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (contracts_2_1 && !contracts_2_1.done && (_b = contracts_2.return)) _b.call(contracts_2);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (accountBalancesInfo_1_1 && !accountBalancesInfo_1_1.done && (_a = accountBalancesInfo_1.return)) _a.call(accountBalancesInfo_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.genericService.addDynamicProductTypeData(this.accountsInfo.contractSummaryResponse, this.productType);
    };
    AccountsComponent.prototype.updateAccountSecondaryInfos = function (accountSecondaryInfos) {
        var e_4, _a, e_5, _b;
        if (!accountSecondaryInfos || accountSecondaryInfos.length === 0) {
            return;
        }
        var contracts;
        try {
            contracts = this.accountsInfo.contractSummaryResponse.contractSummary;
        }
        catch (e) {
            return;
        }
        try {
            for (var accountSecondaryInfos_1 = tslib_1.__values(accountSecondaryInfos), accountSecondaryInfos_1_1 = accountSecondaryInfos_1.next(); !accountSecondaryInfos_1_1.done; accountSecondaryInfos_1_1 = accountSecondaryInfos_1.next()) {
                var accountSecondaryInfo = accountSecondaryInfos_1_1.value;
                try {
                    for (var contracts_3 = tslib_1.__values(contracts), contracts_3_1 = contracts_3.next(); !contracts_3_1.done; contracts_3_1 = contracts_3.next()) {
                        var contract = contracts_3_1.value;
                        if (contract.referenceId === accountSecondaryInfo.referenceId) {
                            try {
                                var currentFirstSecondaryValueGroup = void 0;
                                contract.secondaryContractValues = contract.secondaryContractValues || [];
                                contract.secondaryContractValues[0] = contract.secondaryContractValues[0] || { group: [] };
                                contract.secondaryContractValues[0].group = contract.secondaryContractValues[0].group || [];
                                currentFirstSecondaryValueGroup = contract.secondaryContractValues[0].group;
                                contract.secondaryContractValues[0].group =
                                    currentFirstSecondaryValueGroup.concat(accountSecondaryInfo.secondaryContractValues);
                            }
                            catch (e) {
                                // nothing here
                            }
                        }
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (contracts_3_1 && !contracts_3_1.done && (_b = contracts_3.return)) _b.call(contracts_3);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (accountSecondaryInfos_1_1 && !accountSecondaryInfos_1_1.done && (_a = accountSecondaryInfos_1.return)) _a.call(accountSecondaryInfos_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    return AccountsComponent;
}());
export { AccountsComponent };
